@if (this.entity().schemaOrg) {
  <mobi-ld-schema [schema]="entity().schemaOrg" />
}
<mobi-product-hero
  [headerImage]="entity().headerImage"
  [headerImageMobile]="entity().headerImageMobile"
  [title]="entity().title"
  [subtitle]="entity().subtitle"
  [superTitle]="entity().superTitle"
  [lead]="entity().lead"
  [rating]="entity().showProductRating && rating().count > 0 ? rating() : undefined"
  [overviewCta1]="entity().overviewCta1"
  [overviewCta2]="entity().overviewCta2"
  [contentLinks]="contentLinks()"
  [calculatorCta]="entity().calculatorCta | calcCta: entity().calculatorCtaAuth"
  [consultationCta]="entity().consultationCta"
  [consultationCtaTitle]="entity().consultationCtaTitle"
  [calculatorCtaTitle]="entity().calculatorCtaTitle"
></mobi-product-hero>

<!-- make sure to not render as page content -->
@if (entity().paragraphs) {
  @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
    @if (paragraph && paragraph.type === 'ParagraphPgEmbed') {
      <div class="mobi-ui-ink-blue">
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      </div>
    }
  }
}
<div class="page-content">
  @if (entity().paragraphs) {
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        @switch (paragraph.type) {
          @case ('ParagraphPgPfs') {
            @if (entity().inShortTitle) {
              <div class="content-section mobi-ui-ink-blue">
                <div>
                  <mobi-product-in-short
                    [productTitle]="entity().title"
                    [productTitle]="entity().productTitle"
                    [inShortText]="entity().inShortText"
                    [inShortTitle]="entity().inShortTitle ?? ''"
                    [inShortSubtitle]="entity().inShortSubtitle"
                    [advantages]="entity().advantages"
                    [productAward]="entity().productAward"
                    [comboProduct]="
                      entity().comboProduct ? entity().comboProduct : entity().product
                    "
                    [comboProductSectionTitle]="entity().procomTitle"
                    [products]="entity().products"
                    [productsTitle]="entity().productsTitle"
                    [anchorId]="paragraph.anchorLinkUrl || paragraph.id"
                    [video]="entity().video"
                  />
                </div>
              </div>
            }
          }
          @case ('ParagraphPgPfde') {
            @if (entity().damageExamples) {
              <div class="content-section is-background">
                <div>
                  <mobi-product-damage-examples
                    [title]="entity().damageTitle || ''"
                    [damageExamples]="entity().damageExamples ?? []"
                    [damageExampleCta]="entity().damageExampleCta"
                    [anchorId]="paragraph.anchorLinkUrl || paragraph.id"
                  />
                </div>
              </div>
            }
          }
          @case ('ParagraphPgFaq') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgTxt') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgImg') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgVi') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgAc') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgPps') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgCt') {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
          @case ('ParagraphPgEmbed') {}
          @default {
            <div class="mobi-ui-ink-blue">
              <mobi-paragraph-loader
                [bundle]="paragraph.type"
                [data]="{ paragraph: paragraph }"
              />
            </div>
          }
        }
      }
    }
  }
  <mobi-product-how-to-proceed
    [calculatorCta]="entity().calculatorCta | calcCta: entity().calculatorCtaAuth"
    [calculatorCtaTitle]="entity().calculatorCtaTitle"
    [calculatorCtaDescription]="entity().calculatorCtaDescription"
    [consultationCta]="entity().consultationCta"
    [consultationCtaTitle]="entity().consultationCtaTitle"
    [consultationCtaDescription]="entity().consultationCtaDescription"
  ></mobi-product-how-to-proceed>
</div>
